import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { StatusFlowProcessListComponent } from '../../components/status-flow-process-list/status-flow-process-list.component';

@Component({
  selector: 'app-status-flow-list',
  standalone: true,
  imports: [CommonModule, RouterLink, PageHeaderComponent, StatusFlowProcessListComponent],
  templateUrl: './status-flow-list.component.html',
  styleUrl: './status-flow-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class StatusFlowListComponent {
  readonly appSettings = inject(AppSettings);
}
